import { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { useLocation } from 'react-router-dom';
import { api } from '@rd-web-markets/shared/dist/services/service';

export function useGetCompanyFoldersAndFiles(companyId, specificFolderId) {
  const [folders, setFolders] = useState([]);
  const [files, setFiles] = useState([]);
  const [currentFolderId, setCurrentFolderId] = useState(specificFolderId || null);
  const [currentPath, setCurrentPath] = useState([]);
  const { search } = useLocation();

  const base = `/companies/${companyId}/folders`;

  const getFolderData = useErrorHandling(
    useCallback(async (folderId) => {
      setFolders([]);
      setFiles([]);

      if (folderId) {
        const response = await api.get(`${base}/${folderId}`);
        setFolders([
          ...response.subfolders,
          ...(response.project_virtual_folders || []),
          ...(response.claim_group_virtual_folders || []),
        ]);
        setFiles([
          ...response.folder_files,
          ...(response.files_from_other_folders || []),
        ]);
        setCurrentPath([...response.folder_path]);
      } else {
        const response = await api.get(base);
        setFolders([...response]);
        setCurrentPath([]);
      }
    }, [base])
  );

  const getFilesData = useErrorHandling(
    useCallback(async () => {
      const response = await api.get(`/companies/${companyId}/folder_files`);
      setFiles([...response]);
    }, [companyId])
  );

  useEffect(() => {
    const params = new URLSearchParams(search);
    const folderId = params.get('folder_id') || specificFolderId || null;

    setCurrentFolderId(folderId);

    if (!folderId) {
      getFolderData(null);
      getFilesData();
    } else {
      getFolderData(folderId);
    }
  }, [search, specificFolderId, getFolderData, getFilesData]);

  return [setFolders, setFiles, setCurrentFolderId, currentFolderId, folders, files, currentPath];
}
